import React from "react";
function Techstack() {
  const journey = [
    {
      year: "2022",
      phase: "Foundation",
      entries: [
        {
          title: "Choicest Fruit® Established",
          text: "Founded with a mission to empower communities through technology, education, and hands-on learning experiences.",
        },
      ],
    },
    {
      year: "2023",
      phase: "Building the Platform",
      entries: [
        {
          title: "Domain & Digital Presence Launched",
          text: "Secured our online presence and began building the foundation for accessible community programs.",
        },
        {
          title: "YouTube Channel Created",
          text: "Launched our YouTube channel to share educational content, program highlights, and learning resources with a broader audience.",
        },
      ],
    },
    {
      year: "2024",
      phase: "First Public Partnerships",
      entries: [
        {
          title: "City of Austin & Travis County Partnership (Summer Youth Employment Program)",
          text: "Partnered to provide youth with meaningful, real-world work experience, introducing participants to technology, teamwork, and career pathways.",
        },
      ],
    },
    {
      year: "2025",
      phase: "Expansion & Program Development",
      entries: [
        {
          title: "Continued City of Austin Partnership (SYEP 2025)",
          text: "Expanded youth internship opportunities and deepened collaboration with local workforce initiatives.",
        },
        {
          title: "Afterschool Programs Introduced (Kyle Apartment Communities)",
          text: "Brought accessible, neighborhood-based learning directly to families, focusing on youth engagement and skill-building.",
        },
        {
          title: "Code & Soil Program Launched",
          text: "Started a unique neighborhood program combining technology, entrepreneurship, and urban gardening to connect learning with real-world application.",
        },
        {
          title: "Ambassador Program Launched",
          text: "Created leadership pathways for youth and young adults to contribute, mentor, and grow within the community.",
        },
        {
          title: "Smart & Sharp Senior Program Initiated",
          text: "Introduced digital literacy and technology access programs for seniors in community centers.",
        },
        {
          title: "Favrhood Platform Developed",
          text: "Built a neighborhood-based platform designed to connect people, opportunities, and local services within communities.",
        },
        {
          title: "Applied for Career School Certification",
          text: "Submitted application to the Texas Workforce Commission to formalize training programs and expand workforce development efforts.",
        },
      ],
    },
    {
      year: "2026",
      phase: "Scaling Impact",
      entries: [
        {
          title: "City of Austin & Travis County Partnership (SYEP 2026)",
          text: "Continued partnership, strengthening pathways for youth to gain real-world experience and skills.",
        },
        {
          title: "Afterschool Programs Implemented & Expanded",
          text: "Expanded neighborhood-based programs in apartment communities, increasing accessibility and participation.",
        },
        {
          title: "Code & Soil Program Continued",
          text: "Deepened community engagement through ongoing neighborhood-based learning and hands-on projects.",
        },
        {
          title: "Ambassador Program Expanded (Favrhood Interns)",
          text: "Integrated ambassadors into real-world projects through Favrhood, strengthening leadership and practical experience.",
        },
        {
          title: "Smart & Sharp Senior Program Expanded",
          text: "Continued supporting seniors with digital skills, access, and confidence in using technology.",
        },
        {
          title: "Course Catalog Approved",
          text: "Received approval of our course catalog from the Texas Workforce Commission, marking a major step toward becoming a certified career school.",
        },
        {
          title: "Favrhood App Rollout",
          text: "Began rolling out Favrhood across neighborhoods, enabling local connections, opportunities, and community-driven collaboration.",
        },
      ],
    },
  ];

  return (
    <section className="story-journey">
      <ol className="story-timeline" aria-label="Our Journey timeline">
        {journey.map((milestone) => (
          <li key={milestone.year} className="timeline-item">
            <span className="timeline-dot" aria-hidden="true" />
            <div className="policy-card timeline-card">
              <div className="timeline-header">
                <span className="timeline-year">{milestone.year}</span>
                <span className="timeline-phase">{milestone.phase}</span>
              </div>

              <div className="timeline-entries">
                {milestone.entries.map((entry) => (
                  <div key={entry.title} className="timeline-entry">
                    <h3 className="timeline-entry-title">{entry.title}</h3>
                    <p className="about-text timeline-entry-text">{entry.text}</p>
                  </div>
                ))}
              </div>
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
}

export default Techstack;
